<template>
  <div class="progress-bar-background">
    <div class="progress-bar" :style="{ width: percentComplete + '%' }"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    percentComplete: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.progress-bar-background {
  z-index: 1;
  height: 11px;
  border-radius: 5.5px;
  border: 1px solid rgba(48, 40, 37, 0.23);
}

.progress-bar {
  position: relative;
  top: -1px;
  left: -1px;
  height: 11px;
  border-radius: 5.5px;
  background-color: #df542f;
  z-index: 2;
  text-align: center;
  line-height: 2.25rem;
  color: black;
}
</style>
